export default __webpack_public_path__ + "static/media/greed-medium.92a35b79.otf";